import styles from './TabBar.module.scss';
import starIcon from '@/assets/productCenter/phonics/phonics-star.png';

interface TabBarProps {
  titles: string[];
  active: number;
  onChange?: (index: number) => void;
  className?: string;
}

export default function TabBar({ titles, active, onChange, className }: TabBarProps) {
  return (
    <div className={[styles.tabBar, className].filter(Boolean).join(' ')} role="tablist">
      <div
        className={styles.tabIndicator}
        style={{
          transform: `translateX(${active * 100}%)`,
        }}
      />
      {titles.map((title, index) => {
        const isActive = index === active;
        return (
          <button
            key={title}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`${styles.tabItem} ${isActive ? styles.tabItemActive : ''}`}
            onClick={() => onChange?.(index)}
          >
            <span className={styles.tabText}>{title}</span>
            <img
              src={starIcon}
              alt=""
              className={`${styles.tabStar} ${isActive ? styles.tabStarActive : ''}`}
            />
          </button>
        );
      })}
    </div>
  );
}
